import { render, staticRenderFns } from "./operateDialog.vue?vue&type=template&id=1b6bc86c&scoped=true&"
import script from "./operateDialog.vue?vue&type=script&lang=js&"
export * from "./operateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6bc86c",
  null
  
)

export default component.exports